<div class="card mb-2">
  <div class="d-flex justify-content-center pt-2"><h3>Add Product Info Bulletin</h3> </div>
  <form class="p-4" [formGroup]="emailBullitenForm">
    <div class="form-group">
      <div class="row d-flex justify-content-start">
        <div class="col-4">
          <label for="subject">Communication Group</label>
        </div>
        <div class="col-6">
          <div *ngIf="communicationGroupList.length > 0" class="w-100">
            <ng-select [items]="communicationGroupList" bindLabel="communicationGroup" bindValue="communicationGroupCode" formControlName="communicationGroup" required>
            </ng-select>
          </div>
        </div>
        <!-- upload file with .eml extension only -->
      </div>
      <div class="col-4 pb-2 d-flex justify-content-start">
        <input type="file" accept=".eml" id="fileInput" (change)="onFileSelected($event)" hidden formControllerName="fileName" />
        <label for="fileInput" class="custom-file-upload"> Choose File </label>
      </div>
      <div class="col-4 pb-2 d-flex justify-content-start">
        <span *ngIf="fileName">{{ fileName }}</span>
      </div>
 
    </div>
  </form>
</div>
<div class="modal-footer">
  <button class="btn" [disabled]="!emailBullitenForm.valid" (click)="onUpload()">UPLOAD</button>
  <button class="btn  btn-cancel"  (click)="cancel()">Cancel</button>
</div>

